import React from "react";
import { useNavigate } from "react-router";
import { ICategoria } from "../../../model/categoria";
import textUtils from "../../../utils/textUtils";
import { useImageSrc } from "../../../utils/imageFallback";
import { InfoThinCategoryContainer, ThinCategoryCardContainer } from "./styles";

export const ThinCategoryCard = ({ nome, imagem, routePrefix }: ICategoria) => {
  const navigate = useNavigate();

  const handleClick = React.useCallback(() => {
    navigate(`/${routePrefix}/${textUtils.routeFormater(nome)}`);
  }, [navigate, routePrefix, nome]);

  const imageSrc = useImageSrc(imagem);

  return (
    <ThinCategoryCardContainer
      type="button"
      aria-label={`Abrir categoria ${nome}`}
      onClick={handleClick}
    >
      <InfoThinCategoryContainer title={nome} image={imageSrc}>
        <h5>{nome}</h5>
      </InfoThinCategoryContainer>
    </ThinCategoryCardContainer>
  );
};

export default ThinCategoryCard;
